export default __webpack_public_path__ + "ec1dfad067cf80d1f4fcbe71f8ff19e1.svg";